import React, { useState } from 'react';
import { X } from 'lucide-react';

export function ChipInput({ value = [], onChange, placeholder, color = '#0076A3', testid }) {
  const [draft, setDraft] = useState('');

  const add = (raw) => {
    const parts = raw.split(',').map((s) => s.trim()).filter(Boolean);
    if (!parts.length) return;
    const next = [...value];
    parts.forEach((p) => { if (!next.some((x) => x.toLowerCase() === p.toLowerCase())) next.push(p); });
    onChange(next);
    setDraft('');
  };
  const remove = (i) => onChange(value.filter((_, idx) => idx !== i));

  return (
    <div>
      {value.length > 0 && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 8 }}>
          {value.map((s, i) => (
            <span key={s + i} style={{ display: 'inline-flex', alignItems: 'center', gap: 4, padding: '3px 6px 3px 10px', borderRadius: 999, background: `${color}14`, border: `1px solid ${color}33`, fontSize: 12, color, fontWeight: 600 }}>
              {s}
              <button type="button" onClick={() => remove(i)} data-testid={`${testid}-remove-${i}`} aria-label={`Remove ${s}`} style={{ background: 'none', border: 'none', cursor: 'pointer', display: 'flex', color, padding: 2 }}>
                <X size={12} />
              </button>
            </span>
          ))}
        </div>
      )}
      <input
        value={draft}
        data-testid={testid}
        onChange={(e) => setDraft(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ',') { e.preventDefault(); add(draft); }
          else if (e.key === 'Backspace' && !draft && value.length) { remove(value.length - 1); }
        }}
        onBlur={() => draft && add(draft)}
        placeholder={placeholder}
        style={{ width: '100%', padding: '0.55rem 0.75rem', borderRadius: 12, border: '1px solid #ECE7DE', background: '#fff', fontSize: '0.8125rem', color: '#002A38', outline: 'none', boxSizing: 'border-box' }}
      />
      <div style={{ fontSize: '0.625rem', color: '#94A3B8', marginTop: 4 }}>Press Enter or comma to add</div>
    </div>
  );
}
